import React, { useState } from 'react';
import { signInWithPopup } from 'firebase/auth';
import { auth, provider } from '../firebase';
import { useNavigate } from 'react-router-dom';

export default function LoginPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError('');
    try {
      await signInWithPopup(auth, provider);
      navigate('/app');
    } catch (err) {
      setError('Sign-in failed. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', background: '#0D0D1A',
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{
        background: '#1A1A2E', border: '1px solid #2A2A4A',
        borderRadius: 20, padding: '48px 40px', width: '100%', maxWidth: 420, textAlign: 'center'
      }}>
        
        {/* Logo */}
        <div style={{
          width: 52, height: 52, background: 'linear-gradient(135deg, #0F7DFF, #00D4AA)',
          borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 26, margin: '0 auto 20px'
        }}>⚡</div>

        <h2 style={{
          fontFamily: 'Space Grotesk, sans-serif', fontSize: 26,
          fontWeight: 700, marginBottom: 8
        }}>Welcome to ApplyEdge</h2>

        <p style={{ color: '#8888AA', fontSize: 14, marginBottom: 36, lineHeight: 1.6 }}>
          Sign in to access your account and credits
        </p>

        {error && (
          <div style={{
            background: 'rgba(255,107,107,0.1)', border: '1px solid #FF6B6B',
            borderRadius: 10, padding: '12px', marginBottom: 20,
            color: '#FF6B6B', fontSize: 14
          }}>{error}</div>
        )}

        <button onClick={handleGoogleLogin} disabled={loading} style={{
          width: '100%', padding: '14px', borderRadius: 12,
          border: '1px solid #2A2A4A', background: '#0D0D1A',
          color: '#fff', fontFamily: 'Inter, sans-serif', fontWeight: 600,
          fontSize: 15, cursor: loading ? 'not-allowed' : 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12,
          opacity: loading ? 0.7 : 1
        }}>
          <img src="https://www.google.com/favicon.ico" alt="Google" width={18} height={18} />
          {loading ? 'Signing in...' : 'Continue with Google'}
        </button>

        <p style={{ color: '#555570', fontSize: 12, marginTop: 24, lineHeight: 1.6 }}>
          By signing in, you agree to our{' '}
          <a href="https://applyedge44.github.io/applyedge-privacy/privacy-policy.html"
            target="_blank" rel="noreferrer" style={{ color: '#0F7DFF' }}>Privacy Policy</a>
        </p>

      </div>
    </div>
  );
}